import { render, staticRenderFns } from "./ProgressoProjetos.vue?vue&type=template&id=5ec72c71&scoped=true&"
import script from "./ProgressoProjetos.vue?vue&type=script&lang=js&"
export * from "./ProgressoProjetos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec72c71",
  null
  
)

export default component.exports